import Vue from 'vue'

export function showSuccess(msg: string) {
  Vue.notify({
    title: msg,
    type: 'success',
  })
}

export function showError(msg: string) {
  console.log(msg);
  Vue.notify({
    title: msg,
    type: 'error'
  })
}

export function showWarning(msg: string) {
  console.log(msg);
  Vue.notify({
    title: msg,
    type: 'warning'
  })
}

export function showUnknownError() {
  showError('Ein unbekannter Fehler ist aufgetreten')
}

